import { FastApiAxiosInstance } from 'common/service/axiosInstances';

const dccCheck = {
  startCheck: (params: { uuid: string; description?: string; fileList?: any; modifyFileList?: any }) => {
    return FastApiAxiosInstance.post('/api/v1/version/uploadEnd', params);
  },
};
export default dccCheck;
